import type { IssuedInvoiceStatus } from '../../../lib/issuedInvoicesApi';

export const ISSUED_STATUS_LABELS: Record<IssuedInvoiceStatus, string> = {
  DRAFT: 'Ciornă',
  SENDING: 'Se trimite',
  SENT: 'Trimisă în SPV',
  ACCEPTED: 'Acceptată de ANAF',
  REJECTED: 'Respinsă de ANAF',
  FAILED: 'Trimitere eșuată',
  CANCELLED: 'Anulată',
};

const STYLES: Record<IssuedInvoiceStatus, string> = {
  DRAFT: 'bg-gray-100 text-gray-700',
  SENDING: 'bg-blue-50 text-blue-700',
  SENT: 'bg-blue-100 text-blue-800',
  ACCEPTED: 'bg-green-100 text-green-800',
  REJECTED: 'bg-red-100 text-red-800',
  FAILED: 'bg-orange-100 text-orange-800',
  CANCELLED: 'bg-gray-100 text-gray-500 line-through',
};

export function IssuedInvoiceStatusBadge({ status }: { status: IssuedInvoiceStatus }) {
  return (
    <span
      className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ${STYLES[status]}`}
    >
      {ISSUED_STATUS_LABELS[status]}
    </span>
  );
}
